<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import store from "../../store";
    import {bus} from "../../vue_bus";
    import {threeMain} from "../../threeJS/threeMain";

    export default {
        name: "WorkspaceFabricGroupSelection",
        mixins: [urlForFileStorage],
        mounted() {
            this.initFabric();
            bus.$on("selectedPlaneFromPlaneVisualisator", (planeID) => {
                const groupID = store.getters["active/ALL_PLANES_FROM_PHOTO"][planeID].idDesignGroup;
                if (!groupID)
                  return;

                if (groupID != this.$route.params.groupID) {
                    this.$router.replace({
                      name: "groupingPlanesActive",
                      params: {groupID: groupID},
                      query: this.$route.query
                    }).catch(() => {
                    });
                }
            })
            bus.$on("unSelectedPlaneFromPlaneVisualisator", () => {

            })
            bus.$on("dblclickPlaneFromPlaneVisualisator", (planeID) => {
                const groupID = store.getters["active/ALL_PLANES_FROM_PHOTO"][planeID].idDesignGroup;
                if (!groupID)
                  return;

                this.$router.push({name: 'groupingPlanesActiveEditGroup',
                  params: {groupID: groupID},
                  query: this.$route.query}).catch(err=>{});
            })

            bus.$on('refreshFabric', () => {
                this.editor.destroy();
                this.initFabric();
            })
        },
        destroyed() {
            bus.$off("dblclickPlaneFromPlaneVisualisator");
            bus.$off("selectedPlaneFromPlaneVisualisator");
            bus.$off("refreshFabric");
            this.editor.destroy();
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            }
        },
        methods: {
            initFabric: async function () {
                this.editor = new fabricEditor(this.$refs["fabricJS"]);
                this.editor.updateCanvaSize({
                        width: this.$refs["fabricJSContainer"].offsetWidth,
                        height: this.$refs["fabricJSContainer"].offsetHeight
                    }
                )
                let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
                await this.editor.showPlanes();
                this.editor.setViewport(source, 1);
            }
        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
